import type { Tile } from './tile.ts';

export const LANE_SIZE = 22;
export const INITIAL_DOWN_COUNT = 17;
export const INITIAL_UP_COUNT = 5;

export type LaneSlot = {
  tile: Tile;
};

export type PlayerLane = {
  slots: LaneSlot[];
};
